import * as Config from '../data/Config';
import { timeoutPromise } from '.';
import * as S3 from 'aws-sdk/clients/s3';
import * as Lambda from 'aws-sdk/clients/lambda';
const AWS = require('aws-sdk/global');

export const bucketInternalBaseUrl = 's3://beatflyer-test/';

AWS.config.update({
  correctClockSkew: true,
  region: Config.S3_BUCKET_REGION,
  credentials: new AWS.Credentials({
    accessKeyId: Config.AWS_ACCESS_KEY,
    secretAccessKey: Config.AWS_SECRET_ACCESS_KEY
  }),
  httpOptions: {
    timeout: 0
  }
});

AWS.events.on('retry', function (response: any) {
  if (response.error.name === 'RequestTimeTooSkewed') {
    console.warn('Could not upload file because of RequestTimeTooSkewed error');
    var serverTime = Date.parse(response.httpResponse.headers['date']);
    var timeNow = new Date().getTime();
    AWS.config.systemClockOffset = Math.abs(timeNow - serverTime);
    response.error.retryable = true;
    console.log('Setting systemClockOffset to:', AWS.config.systemClockOffset);
    console.log('Retrying uploading to S3 once more...');
  }
});

const s3private = new S3({
  apiVersion: '2006-03-01',
  params: { Bucket: Config.S3_BUCKET_NAME }
});
export const s3 = s3private;

const lambdaPrivate = new Lambda({
  apiVersion: '2015-03-31'
});
export const lambda = lambdaPrivate;

export const MediaConvertNameModifier = '-render';

export const generateConversionParams = (
  videoUrl: string,
  audioUrl?: string
): any => {
  const FileInput = videoUrl; // e.g. s3://beatflyer-test/muted-flyer.webm
  const ExternalAudioFileInput = audioUrl;
  return {
    Queue: 'arn:aws:mediaconvert:eu-west-1:573000482831:queues/Default',
    Role: 'arn:aws:iam::573000482831:role/MediaConvert',
    Settings: {
      TimecodeConfig: {
        Source: 'ZEROBASED'
      },
      OutputGroups: [
        {
          Name: 'File Group',
          Outputs: [
            {
              ContainerSettings: {
                Container: 'MP4',
                Mp4Settings: {
                  CslgAtom: 'INCLUDE',
                  CttsVersion: 0,
                  FreeSpaceBox: 'EXCLUDE',
                  MoovPlacement: 'PROGRESSIVE_DOWNLOAD'
                }
              },
              VideoDescription: {
                ScalingBehavior: 'DEFAULT',
                TimecodeInsertion: 'DISABLED',
                AntiAlias: 'ENABLED', // TODO: this shouldn't be needed
                Sharpness: 50,
                CodecSettings: {
                  Codec: 'H_264',
                  H264Settings: {
                    InterlaceMode: 'PROGRESSIVE',
                    NumberReferenceFrames: 3,
                    Syntax: 'DEFAULT',
                    Softness: 0,
                    GopClosedCadence: 1,
                    GopSize: 90,
                    Slices: 1,
                    GopBReference: 'DISABLED',
                    SlowPal: 'DISABLED',
                    SpatialAdaptiveQuantization: 'ENABLED',
                    TemporalAdaptiveQuantization: 'ENABLED',
                    FlickerAdaptiveQuantization: 'DISABLED',
                    EntropyEncoding: 'CABAC',
                    Bitrate: 4000000,
                    FramerateControl: 'INITIALIZE_FROM_SOURCE',
                    RateControlMode: 'CBR',
                    CodecProfile: 'HIGH',
                    Telecine: 'NONE',
                    MinIInterval: 0,
                    AdaptiveQuantization: 'HIGH',
                    CodecLevel: 'AUTO',
                    FieldEncoding: 'PAFF',
                    SceneChangeDetect: 'ENABLED',
                    QualityTuningLevel: 'SINGLE_PASS_HQ',
                    FramerateConversionAlgorithm: 'DUPLICATE_DROP',
                    UnregisteredSeiTimecode: 'DISABLED',
                    GopSizeUnits: 'FRAMES',
                    ParControl: 'INITIALIZE_FROM_SOURCE',
                    NumberBFramesBetweenReferenceFrames: 2,
                    RepeatPps: 'DISABLED',
                    DynamicSubGop: 'STATIC'
                  }
                },
                AfdSignaling: 'NONE',
                DropFrameTimecode: 'ENABLED',
                RespondToAfd: 'NONE',
                ColorMetadata: 'INSERT'
              },
              AudioDescriptions: [
                {
                  AudioTypeControl: 'FOLLOW_INPUT',
                  AudioSourceName: 'Audio Selector 1',
                  CodecSettings: {
                    Codec: 'AAC',
                    AacSettings: {
                      AudioDescriptionBroadcasterMix: 'NORMAL',
                      Bitrate: 128000,
                      RateControlMode: 'CBR',
                      CodecProfile: 'LC',
                      CodingMode: 'CODING_MODE_2_0',
                      RawFormat: 'NONE',
                      SampleRate: 44100,
                      Specification: 'MPEG4'
                    }
                  },
                  LanguageCodeControl: 'FOLLOW_INPUT'
                }
              ],
              NameModifier: MediaConvertNameModifier
            }
          ],
          OutputGroupSettings: {
            Type: 'FILE_GROUP_SETTINGS',
            FileGroupSettings: {
              Destination: 's3://beatflyer-test/',
              DestinationSettings: {
                S3Settings: {
                  AccessControl: {
                    CannedAcl: 'PUBLIC_READ'
                  }
                }
              }
            }
          }
        }
      ],
      AdAvailOffset: 0,
      Inputs: [
        {
          AudioSelectors: {
            'Audio Selector 1': {
              Offset: 0,
              DefaultSelection: 'DEFAULT',
              ExternalAudioFileInput,
              ProgramSelection: 1
            }
          },
          VideoSelector: {
            ColorSpace: 'FOLLOW',
            Rotate: 'DEGREE_0',
            AlphaBehavior: 'DISCARD'
          },
          FilterEnable: 'AUTO',
          PsiControl: 'USE_PSI',
          FilterStrength: 0,
          DeblockFilter: 'DISABLED',
          DenoiseFilter: 'DISABLED',
          TimecodeSource: 'ZEROBASED',
          FileInput
        }
      ]
    },
    AccelerationSettings: {
      Mode: 'DISABLED'
    },
    StatusUpdateInterval: 'SECONDS_10',
    Priority: 0
  };
};

const getMediaConversionJobStatus = async (jobId: string): Promise<string> => {
  // mc.getJob({ Id: jobId }, (data: any) => {
  //   console.log(data);
  // });
  return '';
};

export const waitForMediaConversionJobCompletion = async (
  jobId: string
): Promise<void> => {
  let status = '';
  while (status !== 'Complete') {
    status = await getMediaConversionJobStatus(jobId);
    if (status !== 'Complete') {
      await timeoutPromise(2000);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/AWSConfig.ts